function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Artboard_23",
    "data-name": "Artboard 23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.477,62A23,23,0,0,1,37.909,26.962l4.933,4.523A22.993,22.993,0,0,1,45.718,36L44,58.965A23.087,23.087,0,0,1,41.523,62Z",
    style: {
      fill: "#2d9739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.718,36a22.993,22.993,0,0,0-2.876-4.515l-4.933-4.524-.087-.059a17.692,17.692,0,0,0-19.63,0A23,23,0,0,0,14.477,62H41.523A23.087,23.087,0,0,0,44,58.965Z",
    style: {
      fill: "#44bc59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.473,33.761a23.078,23.078,0,0,0-1.631-2.276l-2.207-2.024A14.871,14.871,0,0,1,37.208,31.2l-4.372,1.49A1.248,1.248,0,0,0,32,33.878v6.87a1.222,1.222,0,0,0,1.86,1.067l4.393-2.746A28.882,28.882,0,0,0,44.473,33.761Z",
    style: {
      fill: "#2d9739"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 19,
    width: 14,
    height: 4,
    rx: 2,
    style: {
      fill: "#ffc239"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 43,
    r: 12,
    style: {
      fill: "#abe4a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,31a11.927,11.927,0,0,0-6.548,1.952,11.991,11.991,0,0,0,16.6,16.6A11.991,11.991,0,0,0,25,31Z",
    style: {
      fill: "#cdf8c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,19l-2.78-5c-.685-1.662.249-4,1.78-4H31c1.531,0,2.465,2.338,1.78,4L30,19Z",
    style: {
      fill: "#2d9739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,42a2,2,0,1,1,2-2h2a4,4,0,0,0-3-3.858V35H24v1.142A3.992,3.992,0,0,0,25,44a2,2,0,1,1-2,2H21a4,4,0,0,0,3,3.858V51h2V49.858A3.992,3.992,0,0,0,25,42Z",
    style: {
      fill: "#2d9739"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 61,
    width: 60,
    height: 2,
    style: {
      fill: "#ffc239"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 43,
    width: 4,
    height: 16,
    style: {
      fill: "#ffc239"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 36,
    width: 4,
    height: 23,
    style: {
      fill: "#ffc239"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 29,
    width: 4,
    height: 30,
    style: {
      fill: "#ffc239"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.628,40.084a11.99,11.99,0,0,0-4.5-6.724,1.246,1.246,0,0,0-.125.518v6.87a1.222,1.222,0,0,0,1.86,1.067Z",
    style: {
      fill: "#abe4a3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 23,
    width: 4,
    height: 36,
    style: {
      fill: "#ffc239"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 47,
    width: 4,
    height: 12,
    style: {
      fill: "#ffc239"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,19a1.979,1.979,0,0,0-.974.263A2,2,0,0,0,21,21H31a1.979,1.979,0,0,0,.974-.263A2,2,0,0,0,30,19Z",
    style: {
      fill: "#ffd55d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.78,14c.685-1.662-.249-4-1.78-4H20.637A1.49,1.49,0,0,0,19.2,11.981l.008.019,1.481,2.664A4.545,4.545,0,0,0,24.665,17h6.447Z",
    style: {
      fill: "#44bc59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,47v9a2,2,0,0,0,2,2V47Z",
    style: {
      fill: "#ffd55d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,43V56a2,2,0,0,0,2,2V43Z",
    style: {
      fill: "#ffd55d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,36V56a2,2,0,0,0,2,2V36Z",
    style: {
      fill: "#ffd55d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,29V56a2,2,0,0,0,2,2V29Z",
    style: {
      fill: "#ffd55d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,23V56a2,2,0,0,0,2,2V23Z",
    style: {
      fill: "#ffd55d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.505,14.269a1,1,0,0,1-1.236,1.236L53,14h0c-2.52,8.377-7.434,16.522-14.747,21.092L33.86,37.838A1.222,1.222,0,0,1,32,36.771V29.9a1.248,1.248,0,0,1,.836-1.186l4.372-1.49C43.058,25.231,48.791,19.184,50,13l-4.459-2.229a1,1,0,0,1-.107-1.727L54.859,2.76a1,1,0,0,1,1.516.557Z",
    style: {
      fill: "#f3a606"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.86,35.246,38.253,32.5c6.793-4.245,11.516-11.576,14.174-19.312a1.986,1.986,0,0,1,2.429-1.25l3.413.975a.982.982,0,0,0,.814-.124L56.375,3.317a1,1,0,0,0-1.516-.557L45.434,9.044a1,1,0,0,0,.107,1.727L50,13c-1.209,6.184-6.942,12.231-12.792,14.225l-4.372,1.49A1.248,1.248,0,0,0,32,29.9V34.18A1.222,1.222,0,0,0,33.86,35.246Z",
    style: {
      fill: "#ffc239"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarning);
export default __webpack_public_path__ + "static/media/earning.5218f295fbfb025876505431d384f0dd.svg";
export { ForwardRef as ReactComponent };